"use client";

import { FormEvent, useState } from "react";
import Button from "@/components/ui/Button";
import Card from "@/components/ui/Card";
import Input from "@/components/ui/Input";
import Select from "@/components/ui/Select";
import { useRouter } from "next/navigation";

export default function ProductForm() {
    const router = useRouter();

    const [form, setForm] = useState({
        name: "",
        sku: "",
        category: "Dress",
        sourceOrigin: "Bangkok",
        material: "",
        description: "",
        coverImage: "",
        color: "Pink",
        size: "S",
        stock: 0,
        reserved: 0,
        salePrice: 0,
        costPrice: 0,
    });

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        await fetch("/api/products", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(form),
        });

        router.push("/products");
        router.refresh();
    };

    return (
        <Card>
            <form className="grid gap-4 md:grid-cols-2" onSubmit={handleSubmit}>
                <div>
                    <label className="mb-1 block text-sm font-medium">Product name</label>
                    <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Base SKU</label>
                    <Input value={form.sku} onChange={(e) => setForm({ ...form, sku: e.target.value })} required />
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Category</label>
                    <Select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
                        <option>Dress</option>
                        <option>Tops</option>
                        <option>Skirt</option>
                        <option>Set</option>
                    </Select>
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Origin</label>
                    <Select value={form.sourceOrigin} onChange={(e) => setForm({ ...form, sourceOrigin: e.target.value })}>
                        <option>Bangkok</option>
                        <option>Hong Kong</option>
                    </Select>
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Material</label>
                    <Input value={form.material} onChange={(e) => setForm({ ...form, material: e.target.value })} />
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Cover image URL</label>
                    <Input value={form.coverImage} onChange={(e) => setForm({ ...form, coverImage: e.target.value })} />
                </div>
                <div className="md:col-span-2">
                    <label className="mb-1 block text-sm font-medium">Description</label>
                    <Input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
                </div>

                <div className="md:col-span-2 mt-2 border-t border-rose-100 pt-4">
                    <h3 className="mb-3 text-lg font-semibold">Initial variant</h3>
                </div>

                <div>
                    <label className="mb-1 block text-sm font-medium">Color</label>
                    <Input value={form.color} onChange={(e) => setForm({ ...form, color: e.target.value })} />
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Size</label>
                    <Input value={form.size} onChange={(e) => setForm({ ...form, size: e.target.value })} />
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Stock</label>
                    <Input type="number" value={form.stock} onChange={(e) => setForm({ ...form, stock: Number(e.target.value) })} />
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Reserved</label>
                    <Input type="number" value={form.reserved} onChange={(e) => setForm({ ...form, reserved: Number(e.target.value) })} />
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Sale price</label>
                    <Input type="number" value={form.salePrice} onChange={(e) => setForm({ ...form, salePrice: Number(e.target.value) })} />
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Cost price</label>
                    <Input type="number" value={form.costPrice} onChange={(e) => setForm({ ...form, costPrice: Number(e.target.value) })} />
                </div>

                <div className="md:col-span-2 flex justify-end">
                    <Button type="submit">Save Product</Button>
                </div>
            </form>
        </Card>
    );
}